module.exports = __webpack_public_path__ + "225db632ea86ceb10db74fb33fa4b068.pdf";